import { FormBlock } from '../blocks/form';

const popup = document.querySelector('.popup');

if (popup) {
  const popupContent = popup.querySelector('.popup__content');
  const closeButton = popup.querySelector('.popup__close');
  const downloadLinks = document.querySelectorAll(`a[href^="${siteurl}/download/"]`);

  closeButton.addEventListener('click', () => popup.classList.remove('popup--visible'));

  popup.addEventListener('click', (e) => {
    if (e.target.classList.contains('popup')) {
      popup.classList.remove('popup--visible');
    }
  });

  window.addEventListener('keydown', (e) => {
    if (e.code === 'Escape') {
      popup.classList.remove('popup--visible');
    }
  });

  downloadLinks.forEach((link) => {
    const href = link.href;

    if (href) {
      fetch(ajaxurl + '?action=can_download&url=' + encodeURI(href))
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            link.classList.add(data.data.gated ? 'gated' : 'non-gated');
          }
        });
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();

      if (getCookie('wp-vb-token')) {
        return window.open(link.href, '_blank');
      }

      popupContent.innerHTML = 'Loading...';
      popup.classList.add('popup--visible');

      fetch(ajaxurl + '?action=get_download_popup&url=' + encodeURI(href))
        .then((response) => response.json())
        .then((data) => {
          if (data.data) {
            popupContent.innerHTML = data.data;

            popupContent.querySelectorAll('.form').forEach((block) => {
              new FormBlock(block);
            });
          } else {
            popup.classList.remove('popup--visible');
            window.location.href = link.href;
          }
        });
    });
  });
}

function getCookie(name) {
  var dc = document.cookie;
  var prefix = name + '=';
  var begin = dc.indexOf('; ' + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  } else {
    begin += 2;
    var end = document.cookie.indexOf(';', begin);
    if (end == -1) {
      end = dc.length;
    }
  }

  return decodeURI(dc.substring(begin + prefix.length, end));
}